<div class="ks-card ks-dialog">

  <div class="ks-card-body ks-scrollbar-neutral">
      <div class="ks-d-flex ks-flex-dir-column ks-mb-6"
           *ngFor="let entity of allowed_completers">
        <div class="ks-d-flex ks-flex-dir-row ks-mb-5">
          <div class="ks-font-size-md">
            {{ entity.label }}
          </div>
          <div class="entity-all">
            <mat-slide-toggle
              [formControl]="entity.allControl">
              All
            </mat-slide-toggle>
          </div>
        </div>

        <div class="ks-w-100 ks-mb-5">
          <kt-autocomplete
            [label]="'Categories'"
            [placeholder]="'Category'"
            [optionsType]="'API'"
            [optionsAPI]= "getCategoriesAutoComplete$(entity.entity_type)"
            [optionType]="'OBJECT'"
            [objectOptionReq]="{
            idKey: 'id',
            dataPath: 'data',
            labelFormatter: entitiesLabelFormatter,
            valueFormatter: entitiesFormatter
          }"
            [isChipList]="true"
            [control]="entity.categoryControl"
          >
          </kt-autocomplete>
        </div>
    </div>

  <div class="ks-card-footer ks-justify-content-end ks-pt-4 ks-pr-0">
    <button class="ks-btn-sm ks-btn-neutral ks-mr-2" (click)="cancel()">Cancel</button>
    <button
      type="button"
      class="ks-btn-sm ks-btn-primary"
      (click)="submit()"
    >
      Send
    </button>
  </div>
</div>
</div>
